<script>
	import { createEventDispatcher } from "svelte";

	import scrollStore from "../../../../stores/scrollStore";

	import PostChild from "./PostChild.svelte";
	import InView from "../../../shared/InView.svelte";

	export let post;

	let highlightOpacity = 0;
	let removeHighlightInverval;

	$: scrollId = $scrollStore?.id;

	let inView = false;

	const dispatch = createEventDispatcher();

	$: handleInViewChange(inView);

	$: handleScrollIdChange(scrollId);

	function handleInViewChange(inView) {
		if (inView) {
			dispatch("inView", { number: post.number });
		}
	}

	function handleScrollIdChange(scrollId) {
		if (scrollId == post.tag) {
			highlightOpacity = 1;
			setTimeout(removeHighlight, 1500);
		}
	}

	function removeHighlight() {
		removeHighlightInverval = setInterval(() => {
			highlightOpacity -= 0.01;
			if (highlightOpacity <= 0) {
				clearInterval(removeHighlightInverval);
			}
		}, 15);
	}
</script>

<div class="flex flex-col relative">
	<div>
		<PostChild {post} />
	</div>
	{#if highlightOpacity > 0}
		<div class="absolute z-50 w-full" style="opacity: {highlightOpacity};">
			<PostChild {post} highlight />
		</div>
	{/if}
	<InView bind:inView />
</div>
